import React from "react";
import { Box, Typography, Link } from "@mui/material";

const Footer = () => {
    return (


        <Box
            component="footer"
            sx={{
                position: "fixed",
                bottom: 0,
                left: 250,
                width: "calc(100% - 250px)",
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "10px 20px",
                backgroundColor: "#f8f9fa",
                color: "#333",
                fontSize: "14px",
                borderTop: "1px solid #ddd",
            }}
        >
            <Typography variant="body2">
                <strong>Copyright © 2025.</strong> All rights reserved.
            </Typography>
            <Typography variant="body2">
                <b>
                    Online Reservation System (by:{" "}
                    <Link
                        href="mailto:helpdesk@pharmevo.biz"
                        target="_blank"
                        rel="noopener noreferrer"
                        sx={{ textDecoration: "none", color: "#0080d4" }}
                    >
                        MIS Department
                    </Link>
                    ) v1.0
                </b>
            </Typography>
        </Box>

    );
};


export default Footer;